import * as constants from './../constants';
import { API_USER_SERVICE_PORT } from '../../config/env/env';
import { setUserInfo } from './authActionCreator';
import store from '../configureStore';
import {
    resetMapviewVehiclesData,
    resetMapviewAllStaffVehiclesData,
} from './mapViewActionCreator';

export const GetCities = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/cities/all`,
        method: 'GET',
        data,
        success: (response) => {
            console.log('GetCities', response.response);
            return {
                type: constants.SET_SETTINGS_CITIES,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetCityZones = (cityId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/${cityId}/zones`,
        method: 'GET',
        success: (response) => {
            console.log('GetCityZones', response.response);
            return {
                type: constants.SET_SETTINGS_CITY_ZONES,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetchZones = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/zones`,
        method: 'POST',
        data,
        success: (response) => {
            console.log('GetchZoneList', response.response);
            return {
                type: constants.SET_SETTINGS_CITY_ZONES,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getWorkLocationZonesWithAssets = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/zones/v2`,
        port: API_USER_SERVICE_PORT,
        method: 'POST',
        data,
        success: (data) => {
            let response = {
                workLocationZones: [],
                zoneClusters: [],
            };
            // Response to have status 200 for all success cases
            if (data && data.status && data.status.code === 200) {
                if (data && data.response && data.response.zones) {
                    response = {
                        workLocationZones: data.response.zones,
                        singleZoneSelect:
                            data?.response?.singleZoneSelect ?? false,
                        isClusteredZones:
                            data?.response?.clusteredZones ?? false,
                        zoneClusters: data?.response?.zoneClusters ?? [],
                    };
                }
            }
            return {
                type: constants.GET_ZONES_LIST,
                payload: response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetStates = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/states`,
        method: 'GET',
        data,
        success: (response) => {
            console.log('GetStates', response.response);
            return {
                type: constants.SET_SETTINGS_STATE,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetCityByState = (stateId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/getcities?stateId=${stateId}`,
        method: 'GET',
        success: (response) => {
            console.log('GetStates', response.response);
            return {
                type: constants.SET_SETTINGS_CITIES,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const fetchPreferredWorkLocations = (leadId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/lead/${leadId}/preferred-work-locations`,
        method: 'POST',
        success: (response) => {
            console.log('SET_PREFERRED_WORK_LOCATIONS', response.response);
            return {
                type: constants.SET_PREFERRED_WORK_LOCATIONS,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetOrgs = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/orgs/all`,
        method: 'GET',
        success: (response) => {
            console.log('SET_ORGANIZATION', response.response);
            return {
                type: constants.SET_ORGANIZATION,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const ChangeOrg = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/orgs/${id}`,
        method: 'PUT',
        success: (response) => {
            console.log('changeOrg', response.response);
            const storeInfo = store?.getState()?.settings?.basicDetails ?? {};
            const storeUserInfo = store?.getState()?.user ?? {};
            const data = {
                status: response.status,
                response: {
                    token: response.response.token,
                    userBO: {
                        ...storeUserInfo,
                    },
                },
            };
            store.dispatch(setUserInfo(data));
            store.dispatch(
                StoreOrganisation({
                    ...storeInfo,
                    name: response.response.orgName,
                    id: response.response.orgId,
                }),
            );
            store.dispatch(resetMapviewVehiclesData());
            store.dispatch(resetMapviewAllStaffVehiclesData());
            return {
                type: constants.DO_NOTHING,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const GetDeliveryHubs = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/all`,
        method: 'POST',
        data,
        success: (response) => {
            console.log('GetPaymentReport', response.response);
            return {
                type: constants.SET_SETTINGS_HUBS,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetDeliveryBDOrgs = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/all/bluedartstores`,
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_HUBS,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
// The hubs behind one Blue Dart store. The store grid collapses them into a single row, so this
// is the only way to reach the individual hubs the edit action operates on. DO_NOTHING because
// the list is per-expanded-row state, not a page-level store slice.
export const GetBluedartStoreHubs = (storeId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/bluedart/store/${encodeURIComponent(storeId)}/hubs`,
        method: 'GET',
        hideNotify: true,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const GetBusinessList = (orgId, filter = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/business/list/${orgId}/all`,
        method: 'POST',
        data: filter,
        success: (response) => {
            console.log('GetBusinessList', response.response);
            return {
                type: constants.SET_BUSINESS_LIST,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// Whether a BD store is already mapped to a zone. Only decides whether the Add Hub form asks for
// one — the create API applies the same rule regardless of what the form showed.
export const GetBluedartStoreZone = (storeId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/bluedart/store-zone?storeId=${encodeURIComponent(storeId)}`,
        method: 'GET',
        hideNotify: true,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const GetBluedartZones = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/hubs/bluedart/zones',
        method: 'GET',
        hideNotify: true,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const CreateHub = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/hubs/',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const EditHub = ({ ...data }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/hubs/' + data.hubs[0].id,
        method: 'PUT',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const DeleteHub = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/hubs/' + id,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const GetOrganisations = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/organisations/' + id,
        method: 'GET',
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_BASIC_DATA,
                payload: response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const SetOrganisations = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/organisations/',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const StoreOrganisation = (data) => ({
    type: constants.SET_SETTINGS_BASIC_DATA,
    payload: data,
});

// VENDOR APIs
export const createVendor = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const createBDVendor = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor/bluedart',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editVendor = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor',
        method: 'PUT',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const deleteVendor = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor/' + id,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// export const getAllVendorList = (onSuccess, onError) => ({
//     type: constants.API,
//     payload: {
//         url: '/org/vendor',
//         method: 'GET',
//         data: {},
//         success: (response) => {
//             return { type: constants.DO_NOTHING, payload: response };
//         },
//         postProcessSuccess: onSuccess,
//         postProcessError: onError,
//         port: API_USER_SERVICE_PORT,
//     },
// });

export const getAllVendorsDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor/all',
        method: 'GET',
        data,
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_VENDORS_LIST,
                payload: response?.response?.vendors ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getAllBDVendorsDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor/all/bluedart',
        method: 'GET',
        data,
        success: (response) => {
            // Keep the full envelope — the screen pages server-side and needs
            // totalCount/totalPages alongside the vendors array.
            return {
                type: constants.SET_SETTINGS_BD_VENDORS_LIST,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// CLIENT APIs
export const createCustomer = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/customer',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editCustomer = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/customer',
        method: 'PUT',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const deleteCustomer = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/customer/' + id,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const createEvVehicle = (payload, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/create`,
        method: 'POST',
        data: payload,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editEvVehicle = ({ id, payload }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/${id}/update`,
        method: 'POST',
        data: payload,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const deleteEvVehicle = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/${id}/delete`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const bulkUploadEvVehicles = (payload, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/upload`,
        method: 'POST',
        data: payload,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getAllCustomersDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/customer/all',
        method: 'GET',
        data,
        success: (response) => {
            console.log('getAllCustomersDetailsresponseeee', response);
            return {
                type: constants.SET_SETTINGS_CLIENTS_LIST,
                payload: response?.response?.customers ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVVehicles = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/all',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_EV_VEHICLES_LIST,
                payload: response?.response ?? {
                    lineItems: [],
                    totalCount: 0,
                },
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVVehiclesV2 = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/all/v2',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_EV_VEHICLES_LIST_V2,
                payload: response?.response ?? {
                    lineItems: [],
                    totalCount: 0,
                },
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const blockUnblockEV = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/control',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const energyControlEV = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/energy/control',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const evBlockAPI = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/block',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const evBlockIotAPI = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/block/iot',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const evBlockEnergyAPI = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/block/energy',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVVendors = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/vendors',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_EV_VENDOR_DATA,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getEVVendorLocations = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${data?.staffId}/vendor/${data?.vendorId}/location`,
        method: 'POST',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: null,
                payload: [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
// Vendor locations (with address) mapped to a city, used to populate the
// "Address" dropdown in the Untag EV popup.
export const getEVCityVendors = (cityId, vendorId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/city/${cityId}/vendors`,
        method: 'GET',
        data: vendorId != null ? { vendorId } : null,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: response?.response ?? null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVCaptains = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/captains',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_EV_CAPTAIN_DATA,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVCaptainsStaffpay = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/captains/staffpay',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_EV_CAPTAIN_DATA,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVTelematics = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/telematics',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_TELEMATICS_LIST,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVTeams = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/teams',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_EV_TEAM_DATA,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVProjects = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/projects',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_EV_PROJECTS_DATA,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllEVUntagReason = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/untag/reasons',
        method: 'GET',
        data,
        success: (response) => {
            let data = response?.response?.dropDownList;
            data?.map((item) => (item.label = item?.name));
            return {
                type: constants.SET_SETTINGS_EV_UNTAG_REASONS_DATA,
                payload: data ?? [],
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const sendEvCommunication = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/ev/send-communication',
        method: 'POST',
        data,
        success: () => ({
            type: constants.DO_NOTHING,
            payload: null,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getEvTelematicsLive = (evId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/${evId}/telematics-live`,
        method: 'GET',
        success: () => ({
            type: constants.DO_NOTHING,
            payload: null,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getEvOverview = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/${data?.id}/overview`,
        method: 'GET',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: response?.response ?? response ?? null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getEvVehicleHistory = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/${data?.id}/history`,
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_EV_HISTORY_DATA,
                payload: response?.evHistoryLineItems ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getEvCommandHistory = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/${data?.id}/command-history`,
        method: 'GET',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: null,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getEvVehiclePerformance = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/ev/performance`,
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.DO_NOTHING,
                payload: {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// Shift timing APIs
export const fetchShiftTimingList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/all',
        method: 'POST',
        data,
        success: (response) => {
            console.log('fetchShiftTimingList', response);
            return {
                type: constants.SET_SETTINGS_SHIFT_LIST,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const fetchShiftUsersList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/users',
        method: 'POST',
        data,
        success: (response) => {
            console.log('fetchShiftUsersList', response);
            return {
                type: constants.SET_SETTINGS_SHIFT_USER_LIST,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const fetchShiftfilterList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/filter',
        method: 'POST',
        data,
        success: (response) => {
            console.log('fetchShiftfilterList', response);
            return {
                type: constants.SET_SETTINGS_SHIFT_LIST,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const fetchSlotfilterList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/dedicated-slots/filter',
        method: 'POST',
        data,
        success: (response) => {
            return {
                type: constants.SET_SETTINGS_SLOTS_LIST,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const bulkAssignDedicatedSlots = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/dedicated-slots/bulk/assign',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const cancelDedicatedSlotOps = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/dedicated-slots/cancel/ops',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const createShiftTiming = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const createShiftTimingBlueDart = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/bluedartstore',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editShiftTiming = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/${data.id}`,
        method: 'PUT',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// -------------------------------- Slot Capacity Approval --------------------------------
// Percentage-based thresholds + tiered routing (FM/SFM -> Super Admin -> Approver), an
// Approver-decider-gated network-wide upload. See artifacts/slot-capacity-approval-fe-plan.md.

export const changeSlotCapacity = (shiftId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/${shiftId}/capacity-change`,
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getCapacityApprovals = (params = {}, onSuccess, onError) => {
    const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
    return {
        type: constants.API,
        payload: {
            url: `/org/shift/capacity-approval${query ? `?${query}` : ''}`,
            method: 'GET',
            success: (response) => {
                return { type: constants.DO_NOTHING, payload: response };
            },
            postProcessSuccess: onSuccess,
            postProcessError: onError,
            port: API_USER_SERVICE_PORT,
        },
    };
};

export const getCapacityApprovalById = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/${id}`,
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const approveCapacityRequest = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/${id}/approve`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const rejectCapacityRequest = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/${id}/reject`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const supersedeCapacityRequest = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/${id}/supersede`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getCapacityApprovers = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/approvers`,
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const addCapacityApprover = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/approvers`,
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editCapacityApprover = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/capacity-approval/approvers/${id}`,
        method: 'PUT',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const multiOrgSlotBulkUpload = (fileName, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/multi-org-bulk/upload`,
        method: 'POST',
        data: { fileName },
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// used this api for autocomplete drop down showing list of hubs
export const GetAllStaffList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/list-all`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const GetShiftsByStaffHub = (staffid, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/shift/staff/${staffid}`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const AssignShiftToStaff = (staffId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/assign-shift`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const deleteShiftTiming = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/' + id,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const deleteShiftTimingBD = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/bluedart/' + id,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getPresignedUrl = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/orgs/presigned-urls',
        method: 'GET',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const uploadTitanAdjustment = (fileName, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/transaction/earnings/titan-adjustment/upload?fileName=${encodeURIComponent(fileName)}`,
        method: 'POST',
        data: null,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
